import type { InputHTMLAttributes } from "react";
import { Input as UIInput } from "../ui/input";

/** 라벨 없는 순수 입력 원자. 라벨은 molecules/Field 가 감싼다. */
export default function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <UIInput {...props} />;
}
